import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { DeleteBlockDialogProps } from 'components/DeleteBlockDialog/DeleteBlockDialog.types';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { API_DELETE_shiftBlock } from 'requests/DELETE_shiftBlock';
import { toastService } from 'services/toastService';
import { useAPIActions } from 'store/reducers/api/apiSlice';
import { handleGenericErrorMessage } from 'utils/handleGenericErrorMessage';

export const DeleteBlockDialog: FC<DeleteBlockDialogProps> = ({
  isOpen,
  setIsOpen,
  blockId,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const { apiRequest } = useAPIActions();

  const handleDelete = useCallback(() => {
    setIsOpen(false);
    apiRequest(API_DELETE_shiftBlock(blockId), {
      onSuccess: async () => {
        toastService.success(t('success:BLOCK_DELETED'));
        onSuccess?.();
      },
      onError: async (error) => handleGenericErrorMessage(error),
    });
  }, [apiRequest, blockId, onSuccess, setIsOpen, t]);

  return (
    <BKJCenteredDialog
      isOpen={isOpen}
      variant="Danger"
      title={t('dialog:DELETE_BLOCK_CONFIRMATION')}
      text={t('dialog:DELETE_BLOCK_MESSAGE')}
      cancelLabel={t('auth:CANCEL')}
      actionLabel={t('auth:DELETE')}
      onAction={handleDelete}
      onCancel={() => setIsOpen(false)}
      onClose={() => setIsOpen(false)}
    />
  );
};
